exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.word-wrap[data-v-1ef06de7] {\n  display: -webkit-box;\n  /* max-width: 200px; */\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.mh-150[data-v-1ef06de7] {\n  min-height: 150px;\n}\n.w-200[data-v-1ef06de7] {\n  width: 180px;\n}\n.noselect[data-v-1ef06de7] {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n", ""]);

// exports
